import { useState } from 'react';
import { postData } from '../../apiService'
import { useNavigate } from "react-router-dom";

const Newsletter = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage("Please enter a valid email.");
      return;
    }
    setLoading(true);
    try {
      const response = await postData(`Subscribe/SubscribeEmail?email=${email}`, null, navigate);
      if (response.success) {
        setEmail("");
        setMessage(response.message);
      }
      else{
        setMessage(response.message);
      }
    } catch (error) {
      setMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubscribe}>
      <div className="mt-3">
        <div className="ft-heading">Subscribe</div>
        <p className="ps-3">
          புதிய விமர்சனங்கள் மின்னஞ்சலில் பெற:
        </p>

        <div className="d-flex mt-2">
          <input id="subscribeEmail"
            type="email"
            className="form-control custom-input"
            placeholder="Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button
            type="submit"
            disabled={loading}
            className="btn send-btn fw-bold text-white ms-2"
          >
            {loading ? "Subscribing..." : "Subscribe"}
          </button>
        </div>
        {message && (
          <div
            className={`mt-2 small ${message.toLowerCase().includes("thank") ? "text-success" : "text-danger"
              }`}
          >
            {message}
          </div>
        )}
      </div>
    </form>
  )
}

export default Newsletter